<template>
  <div class="hstack justify-content-center position-relative">
    <div class="position-absolute align-center">
      <div v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="d-flex toggle-wrapper p-0" :class="{ 'opacity-50': isDisabled }">
      <label class="p-0 w-100">
        <input v-model="toggleValue" type="radio" :value="true" class="toggle-input" :disabled="isDisabled" />
        <div class="toggle-value-container" v-html="firstLabel"></div>
      </label>
      <label v-if="secondLabel" class="p-0 w-100">
        <input v-model="toggleValue" type="radio" :value="false" class="toggle-input" :disabled="isDisabled" />
        <div class="toggle-value-container" v-html="secondLabel"></div>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    firstLabel: {
      type: String,
      required: true,
    },
    secondLabel: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      toggleValue: null,
    };
  },
  computed: {
    isDisabled() {
      return this.disabled || this.isLoading;
    },
  },
  watch: {
    value() {
      this.toggleValue = this.value;
    },
    toggleValue() {
      this.$emit('input', this.toggleValue);
    },
  },
  created() {
    this.toggleValue = this.value;
  },
};
</script>
